import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import { ThemedCheckCircleIcon, ThemedContentCopyIcon } from "assets/CXFIcons/Designer/ContextActions";
import { useTheme } from "@mui/material/styles";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { IconButton } from "@mui/material";

function ShowAccessToken({ token }) {
  const [showToken, setShowToken] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const theme = useTheme();

  const copyToClipboard = async () => {
    if (!token) return;
    await navigator.clipboard.writeText(token);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500);
  };

  return (
    <Card sx={{ boxShadow: "none !important" }}>
      {/* Header */}
      <SoftBox px={2} pt={2} display="flex" justifyContent="space-between">
        <SoftBox>
          <SoftTypography variant="h6">Access Token</SoftTypography>
          <SoftTypography variant="button" color="text">
            Please click the button to show access token.
          </SoftTypography>
        </SoftBox>

        {showToken && (
          <Tooltip title={isCopied ? "Copied" : "Copy"}>
            <IconButton onClick={copyToClipboard} size="small">
              {isCopied ? (
                <ThemedCheckCircleIcon
                  color={theme.palette.mode === "dark" ? "#AA8BFD" : "#7443FF"}
                />
              ) : (
                <ThemedContentCopyIcon
                  color={theme.palette.mode === "dark" ? "#AA8BFD" : "#7443FF"}
                />
              )}
            </IconButton>
          </Tooltip>
        )}
      </SoftBox>

      {/* Token body */}
      {showToken && (
        <SoftBox
          sx={{
            mx: 2,
            mt: 2,
            p: 2,
            borderRadius: "8px",
            backgroundColor: theme.palette.mode === "dark"
              ? "rgba(255,255,255,0.05)"
              : "rgba(0,0,0,0.05)",
            maxHeight: "215px",
            overflowY: "auto",
          }}
        >
          <SoftTypography
            sx={{
              fontFamily: "monospace",
              fontSize: "12px",
              wordBreak: "break-all",
              whiteSpace: "pre-wrap",
            }}
          >
            {token}
          </SoftTypography>
        </SoftBox>
      )}

      {/* Action */}
      <SoftBox px={2} py={2} display="flex" justifyContent="flex-start">
        <SoftButton
          variant="gradient"
          color="info"
          onClick={() => setShowToken((v) => !v)}
        >
          {showToken ? "Hide Token" : "Show Token"}
        </SoftButton>
      </SoftBox>
    </Card>
  );
}


export default ShowAccessToken;
